import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment  from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-student-listing-report',
  templateUrl: './student-listing-report.component.html',
  styleUrls: ['./student-listing-report.component.css']
})
export class StudentListingReportComponent implements OnInit {
  FilterStudentAdmissionModel = {
    ClassID: 0,
    ParentID: 0,
    SectionID: 0,
    StudentStatus: 0,
    BranchID: 0,
    SessionID: 0,
    FirstName: '',
    RegistrationNumber: '',
    StudentNo: '',    
    CurrentIndex: 0,
    PageSize: 10,
    Print:""
}
  constructor(private activatedRoute: ActivatedRoute,private financeService:FinanceService,private studentService:StudentService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 

    this.activatedRoute.queryParams.subscribe(params => {
        this.FilterStudentAdmissionModel.SessionID = params['SessionID'];
        this.FilterStudentAdmissionModel.SectionID =params['SectionID'];
        this.FilterStudentAdmissionModel.StudentStatus = params['StudentStatus'];
        this.FilterStudentAdmissionModel.ParentID = params['ParentID'];
        this.FilterStudentAdmissionModel.ClassID = params['ClassID'];
        this.FilterStudentAdmissionModel.StudentNo = params['StudentNo'];
        this.FilterStudentAdmissionModel.FirstName = params['FirstName'];
        this.FilterStudentAdmissionModel.RegistrationNumber = params['RegistrationNumber'];
        this.FilterStudentAdmissionModel.CurrentIndex = 0;
        this.FilterStudentAdmissionModel.PageSize = 0;
        this.FilterStudentAdmissionModel.Print = "P";
        
      // this.StudentEnquiryModel.StudentID=this.StudentID ;
      this.SearchStuAdmission ()
  });

  }
  loadingSearch = true;
  ClassSectionList:any;
  BranchDetails:any;
  SearchStuAdmission  () {
    this.spinnerService.show();    
    this.loadingSearch = true;
   this. studentService.SearchStuAdmission(JSON.stringify(this.FilterStudentAdmissionModel)).subscribe( (data)=> {
        this.ClassSectionList = data.ClassSectionList;
        this.BranchDetails=data.BranchDetails
        this.spinnerService.hide();
        this.loadingSearch = false;
        setTimeout( () =>{
         window.print();
       }, 2000);
        
    });
};
  ngOnInit() {
  }

}
